import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InputAdornment } from '@material-ui/core';

import type { TextFieldProps } from '@admin/shared/components/inputs/text-field/text-field';
import { TextField } from '@admin/shared/components/inputs/text-field/text-field';

import { HidePasswordIcon } from '@admin/shared/components/icons/custom/hide-password';
import { ShowPasswordIcon } from '@admin/shared/components/icons/custom/show-password';
import { IconButton } from '@admin/shared/components/buttons/button/icon-button';

export const PasswordInput = (props: TextFieldProps): JSX.Element => {
  const { t } = useTranslation(['login']);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleClickShowPassword = () => {
    setShowPassword((val) => !val);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <TextField
      {...props}
      type={showPassword ? 'text' : 'password'}
      autoComplete="current-password"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              tooltip={showPassword ? t('inputs.hidePassword') : t('inputs.showPassword')}
              disableRipple={true}
              tabIndex={-1}
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}>
              {showPassword ? <HidePasswordIcon /> : <ShowPasswordIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
